import axios from 'axios';

const baseUrl = process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_API_URL 
    : ""; // Пустая строка для использования прокси в разработке

const authService = {
    login: async (username, password) => {
        try {
            const response = await axios.post(`${baseUrl}/api/auth/login`, { username, password });
            if (response.data && response.data.token) {
                localStorage.setItem('token', response.data.token);
                return { success: true, data: response.data };
            }
            return { success: false, error: 'Ошибка авторизации. Пожалуйста, проверьте введённые данные' };
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    return { success: false, error: 'Неверный логин или пароль' };
                }
                if (error.response.status === 500) {
                    return { success: false, error: 'Ошибка на сервере. Попробуйте снова позже' };
                }
                return { success: false, error: 'Произошла ошибка, попробуйте снова' }; // error.response.data.message || 
            } else if (error.request) {
                // Если запрос был сделан, но ответа нет
                return { success: false, error: 'Нет ответа от сервера. Проверьте интернет-соединение' };
            } else {
                // Если ошибка произошла при настройке запроса
                return { success: false, error: 'Неизвестная ошибка при запросе' };
            }
        }
    },
    
    logout: () => {
        localStorage.removeItem('token');
        return { success: true };
    },
};

export default authService;